<template>
  <div class="wizard-page">

    <!-- ================= HEADER ================= -->
    <div class="wizard-header">
      <div class="wizard-progress">
        <div class="progress-left">
          <span>Step {{ progress.step }} of {{ progress.total }}</span>
          <small>{{ progress.label }}</small>
        </div>
        <div class="progress-right">{{ progressPercent }}%</div>
      </div>

      <div class="progress-bar">
        <div class="progress-fill" :style="{ width: progressWidth }"></div>
      </div>
    </div>

    <!-- ================= BODY ================= -->
    <div class="wizard-body">

      <!-- ===================================================== -->
      <!-- STEP 1 → CAMPAIGN INFO -->
      <!-- ===================================================== -->
      <div v-if="progress.step === 1">

        <h1>Create Referral Campaign</h1>
        <p>Define your referral program basics.</p>

        <div class="camp-basic-box">

          <label>Campaign Name</label>
          <input v-model="ref_camp_name" />

          <label>Description</label>
          <textarea v-model="ref_camp_desc"></textarea>

        </div>

      </div>

      <!-- ===================================================== -->
      <!-- STEP 2 → CUSTOMER LIST -->
      <!-- ===================================================== -->
      <div v-if="progress.step === 2">

        <h1>Select Customers</h1>
        <p>Choose how you want to collect referrals.</p>

        <div class="invite-grid">

          <input type="file" ref="csvInput" accept=".csv" style="display:none" @change="handleFileUpload" />

          <div class="invite-card" @click="triggerFileUpload" :class="{ disabled: selectedCustomerType.length>0 }">
            <!-- <div class="invite-icon upload"></div> -->
            <h3>Upload List</h3>
            <p>Import contacts via CSV or Excel spreadsheets.</p>

            <div class="upload-actions">

              <button class="connected-btn small" @click.stop="triggerFileUpload">
                Upload File
              </button>

              <button class="ghost-btn small" @click.stop="downloadSampleCSV">
                Download Sample CSV
              </button>

            </div>

            <div v-if="invfile" class="file-preview">

              <div class="file-info">
                <span class="material-symbols-outlined">description</span>
                <span class="file-name">{{ invfile.name }}</span>
              </div>

              <button class="remove-file-btn" @click="removeFile">
                Remove
              </button>

            </div>
          </div>


          <div class="invite-card" style="cursor:pointer;" :class="{ disabled: invfile || selectedCustomerType.length>0 }">
            <!-- <div class="invite-icon manual"></div> -->
            <h3>Single Invite</h3>
            <p>Add individual leads one by one.</p>

            <div class="upload-actions">

              <button class="connected-btn small" @click.stop="openSingleInvite" :disabled="invfile || selectedCustomerType.length>0">
                Add Invitee
              </button>

              <button @click="clearList()" class="ghost-btn small">
                Clear List
              </button>

            </div>
          </div>

           <div class="invite-card">
            <!-- <div class="invite-icon zapier"></div> -->
            <h3>Connect Zapier</h3>
            <p>Automate lead flow from 5,000+ apps.</p>
            <div class="upload-actions">
              <button v-if="isZapier===false" @click="connectZapNow()" class="connected-btn small">
                Connect
              </button>
               <button v-if="isZapier" class="connected-btn small">
                Connected
              </button>
            </div>
          </div>

        </div>

        <div class="invite-card" style="cursor:pointer; margin-left: 34%; margin-top: 2rem; width: 23em;" :class="{ disabled: invfile }">

            <!-- <div class="invite-icon manual"></div> -->

            <h3>Select Campaign</h3>

            <p>Choose campaign for invite.</p>

            <div class="upload-actions">

              <select class="invite-dropdown"  v-model="selectedCustomerType" @click.stop :disabled="invfile">
                <option value="">Select Campaign</option>
                <option v-for="cmp in camps" :key="cmp.camp_id" :value="cmp.camp_id">{{ cmp.camp_title }}</option>
              </select>

              <button class="connected-btn small" @click.stop="resetCamp()">
                Reset
              </button>

            </div>

          </div>

        <!-- INVITEE LIST -->
        <div v-if="invitees.length" class="invite-list">

          <div class="invite-list-header">
            <h3>Added Customers ({{ invitees.length }})</h3>
          </div>

          <div v-for="(person, index) in invitees" :key="person.id" class="invite-row">
            <div class="invite-info">
              <strong>{{ person.name }}</strong>
              <small>{{ person.email }}</small>
              <small v-if="person.mobile">{{ person.mobile }}</small>
            </div>

            <button class="remove-invite" @click="invitees.splice(index,1)">
              ✕
            </button>
          </div>

        </div>

      </div>

      <!-- ===================================================== -->
      <!-- STEP 3 → TEMPLATE + REFERRAL PREVIEW -->
      <!-- ===================================================== -->
      <div v-if="progress.step === 3">

        <h1>Select Template</h1>
        <p>Customize how your referral program appears.</p>

        <div class="design-layout">

          <!-- LEFT → TEMPLATE SELECT -->
          <div class="">

              <div class="preview-card">

              <!-- BRAND -->
              <div class="preview-brand">

                <div class="preview-logo">
                  <img v-if="businessLogoPreview" :src="businessLogoPreview" />
                </div>

                <h3 class="preview-business">
                  {{ businessName }}
                </h3>

                <!-- <p class="preview-desc">
                  Referral Program
                </p> -->

              </div>

              <!-- TITLE -->
              <h2 class="preview-title">Refer a Friend</h2>

              <p class="preview-subtitle">
                 {{ businessDesc }}
              </p>

              <!-- FORM -->
              <div class="preview-form">

                <label>Your Name</label>
                <input placeholder="John Doe" disabled>

                <label>Friend Name</label>
                <input placeholder="John Doe" disabled>

                <label>Friend Email</label>
                <input placeholder="john@email.com" disabled>

                <label>Friend Mobile</label>

                <div class="preview-phone">
                  <div class="preview-code">+91</div>
                  <input placeholder="**********" disabled>
                </div>

                <label>Message (Optional)</label>
                <textarea placeholder="Write a short message..." disabled></textarea>

                <button class="preview-btn" disabled>
                  Send Referral
                </button>

              </div>

            </div>

          </div>

          <!-- RIGHT → LIVE REFERRAL PREVIEW -->
          <div class="preview-section">

          

            <div class="branding-controls">

              <label>Business Name</label>
              <input v-model="businessName" />

              <label>Business Description</label>
              <input v-model="businessDesc" />

              <label style="margin-top: 1rem;">Business Logo</label>

              <div class="logo-upload-wrapper">

                <input type="file" ref="logoInput" accept="image/*" @change="handleLogoUpload" style="display:none" />

                <div class="logo-drop-area" @click="$refs.logoInput.click()">

                  <!-- LOGO PREVIEW -->
                  <template v-if="logo">

                    <img :src="logo" class="logo-preview" />

                    <div class="logo-overlay">
                      Change Logo
                    </div>

                    <!-- REMOVE BUTTON -->
                    <button class="logo-remove" @click.stop="removeLogo">
                      ✕
                    </button>

                  </template>

                  <!-- PLACEHOLDER -->
                  <template v-else>

                    <div class="logo-placeholder">

                      <span class="material-symbols-outlined">
                        image
                      </span>

                      <strong>Upload Logo</strong>

                      <small>PNG, JPG recommended</small>

                    </div>

                  </template>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>


      <!-- ===================================================== -->
      <!-- STEP 5 → EMAIL AUTOMATION -->
      <!-- ===================================================== -->
      <div v-if="progress.step === 4">

        <h1>Email Automation</h1>

        <div class="toggle-row">
          <span>Enable Email Automation</span>
          <!-- <input type="checkbox" v-model="email_enabled" /> -->
          <ToggleSwitch v-model="email_enabled" />
        </div>

        <div v-for="(item, index) in emailWorkflows" :key="item.id" class="workflow-card">

          <div class="workflow-header">
            <strong>Step {{ index + 1 }}</strong>
            <button @click="removeWorkflow(index)">✕</button>
          </div>


          <!-- <label>Send After (Days)</label> -->
          <div class="delay-row">
            <!-- <input type="number" v-model="item.delay_value" /> -->
            <select v-model="item.delay_value"
                  class="w-full border border-slate-200 rounded-lg p-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary">
                  <option value="" selected="">Send After(Days)</option>
                  <option v-for="d in 7" :key="d" :value="d">
                    {{ d }} Day{{ d > 1 ? 's' : '' }}
                  </option>
                </select>
          </div>

          <label>Subject</label>
          <input v-model="item.subject" />

          <!-- <label>Message</label> -->
          <div class="variable-insert">
            <small>Message:</small>

            <button v-for="variable in emailVariables" :key="variable.key" type="button" class="variable-btn"
              @click="insertVariable(index, variable.key)">
              {{ variable.label }}
            </button>
          </div>
          <textarea v-model="item.message"></textarea>

        </div>

        <button class="add-workflow-btn" @click="addWorkflow">
          + Add Workflow
        </button>

      </div>

      <!-- ===================================================== -->
      <!-- STEP 6 → LIVE LINK -->
      <!-- ===================================================== -->
      <!-- ===================================================== -->
      <!-- STEP 6 → LIVE LINK + EMBED -->
      <!-- ===================================================== -->
      <div v-if="progress.step === 5">

        <h1>Referral Campaign Ready</h1>
        <p>Your referral program is now live.</p>

        <div class="launch-grid">

          <!-- QR SECTION -->
           <div class="qr-card" style="display: block!important;">
            <div class="qr-preview">
              <canvas ref="qrCanvas"></canvas>
            </div>

            <button @click="downloadQR" class="outline-btn full-btn">
              Download QR Code
            </button>
          </div>


          <!-- RIGHT SIDE -->
          <div class="url-section">

            <!-- PUBLIC LINK -->
            <h3>Public Referral Link</h3>

            <div class="url-box">
              <input readonly :value="publicLink" />
              <button @click="copyLink">
                Copy
              </button>
            </div>

            <!-- EMBED SECTION -->
            <div class="embed-section">

              <h3>Embed On Website</h3>

              <div class="code-box">
                <code>{{ embedCode }}</code>
              </div>

              <button class="ghost-btn full-btn" @click="copyEmbed">
                Copy Embed Code
              </button>

            </div>

          </div>

        </div>

      </div>

    </div>

    <!-- ================= FOOTER ================= -->

    <div class="wizard-footer">
      <button @click="backNow()" class="footer-back">Back</button>

      <button v-if="progress.step!=5" @click="nextNow()" class="footer-next">
        {{ progress.step > 3 ? "Create Campaign" : "Continue" }}
      </button>
      <button v-if="progress.step===5" @click="listNow()" class="footer-next">
        Go to List
      </button>
    </div>
    <!-- SINGLE INVITE MODAL -->
    <div v-if="showSingleInvite" class="modal-overlay">

      <div class="modal-card">

        <div class="modal-header">
          <h3>Add Customer</h3>
          <button @click="closeSingleInvite">✕</button>
        </div>

        <div class="modal-body">

          <label>Name</label>
          <input v-model="singleInvite.ref_name" />

          <label>Email</label>
          <input v-model="singleInvite.ref_email" />

          <label>Mobile</label>
          <input v-model="singleInvite.ref_mobile" />

        </div>

        <div class="modal-footer">
          <button class="ghost-btn" @click="closeSingleInvite">Cancel</button>
          <button class="connected-btn" @click="saveSingleInvite">
            Save
          </button>
        </div>

      </div>

    </div>
  </div>
</template>
<script>
  import QRCode from "qrcode";
  import { useRoute } from 'vue-router'
  import {
    getQrUrl
  } from "../apis/qrapis";
  
  import { getIntegration } from "@/apis/intigrationapis";
  import { mainBaseUrl, apiBaseUrl } from "../apis/appconst";
  import { createReferralCampaign, getRefById } from "../apis/referralapis";
  import { useToast } from 'vue-toastification';
  import * as XLSX from "xlsx";
  import ToggleSwitch from "../comps/ToggleSwitch.vue";
   import {
    getCampaignList,getCampaignInvites
  } from "../apis/campaignapis";

  export default {
    components: {
      ToggleSwitch
    },
    name: "ReferralCampaignWizard",
    mounted() {
      this.toast = useToast();
      const route = useRoute();
      this.loadCamps();
      const campId = route.query.campId;
      if (campId && campId != null && campId != undefined) {
        this.initCamp(campId);
      }
       const tmp = sessionStorage.getItem("ldata") || "";
      if (tmp && tmp.length > 0) {
        this.user_id = JSON.parse(tmp).user_id;
        this.loadIntegration("Zapier Auth Code", "zapier");
      }
    },
    data() {
      return {
        selectedCustomerType: "",
        isZapier:false,
        publicLink1: "",
        camps:[],
        emailVariables: [
          { key: "{{first_name}}", label: "First Name" },
          // { key: "{{reward}}", label: "Reward" },
          // { key: "{{referral_link}}", label: "Referral Link" }
        ],
        businessName: "Your Business",
        businessDesc: "Share this opportunity with someone who may benefit.",
        businessLogo: null,
        businessLogoPreview: null,
        emailWorkflows: [
          {
            id: Date.now(),
            step: 1,
            delay_value: "",
            delay_unit: "days",
            trigger: "on_signup",
            subject: "",
            message: ""
          }
        ],
        invitees: [],
        campinvs:[],
        invfile: null,
        showSingleInvite: false,

        singleInvite: {
          ref_name: "",
          ref_email: "",
          ref_mobile: ""
        },
        /* Campaign Info */
        ref_camp_name: "",
        ref_camp_desc: "",

        /* Design */
        selectedTemplate: "temp1",

        /* Reward */
        reward_enabled: true,
        reward_type: "percent",
        reward_value: "",

        /* Email */
        email_enabled: true,
        email_subject: "",
        email_message: "",

        /* Progress */
        progress: {
          step: 1,
          total: 5,
          label: "Campaign Info"
        },

        templates: [
          { id: "temp1", name: "Modern", desc: "Layout 1", image: "/images/rtemp1.jpg" }
        ],

        ref_camp_id: ""
      };
    },

    computed: {
      publicLink() {
        return mainBaseUrl + "referral/" + this.ref_camp_id;
      },
      embedCode() {

        var url = mainBaseUrl + `referral/${this.ref_camp_id}`;

        return `<iframe 
                src="${url}" 
                width="100%" 
                height="600" 
                frameborder="0" 
                scrolling="no"
                style="border:0;border-radius:12px;overflow:hidden;"
              ></iframe>`;
      },


      progressPercent() {
        return Math.round((this.progress.step / this.progress.total) * 100);
      },

      progressWidth() {
        return this.progressPercent + "%";
      },

      businessInitials() {
        return this.businessName
          .split(" ")
          .map(w => w[0])
          .join("")
          .substring(0, 2)
          .toUpperCase();
      }

    },

    watch: {
      "progress.step"(val) {
        if (val === 5) {
          this.$nextTick(() => this.generateQR());
        }
      },
      selectedCustomerType(newVal, oldVal){
        console.log("sdfdsf",newVal);
        console.log("sdfdsf232",oldVal);
        this.loadInvts();
      }
    },

    methods: {
       connectZapNow() {

        let user_id = "";
        const tmp = sessionStorage.getItem("ldata") || "";

        if (tmp) {
          user_id = JSON.parse(tmp).user_id;
        }

        const url = apiBaseUrl+"zapier/connect?rtype=new_camp_ref&user_id="+user_id;
        window.location.href = url;
      },
         async loadIntegration(title, type) {

        try {

          const res = await getIntegration(title, type, this.user_id);

          if (!res.status) {
           this.isZapier = false;
            return false;
          }
          else if (res.int_dt != null) {
            this.isZapier = true;
            return true;
          }
        }
        catch (err) {
          console.error(err);
        }
        this.isZapier = false;
        return false;
      },
      resetCamp(){
        this.selectedCustomerType = "";
        this.invitees = [];
      },
      async loadCamps(){
        const tmp = sessionStorage.getItem("ldata") || "";
          let user_id = "";

          if (tmp && tmp.length > 0) {
            user_id = JSON.parse(tmp).user_id;
          }
         const res = await getCampaignList(
          user_id,
          "",
          "",             // platform (future ready)
          "",
          "",
          "0"
        );

        if (!res.status) return;

        this.camps = res.campaigns;
      },
      async loadInvts(){
        if(this.selectedCustomerType.length<=0){
           this.invitees = [];
          return;
        }
        
         const res = await getCampaignInvites(
          this.selectedCustomerType,
          "none"
        );

        if (!res.status) return;

        this.campinvs = res.invites;
        this.invitees = [];
        for(var x=0;x<this.campinvs.length;x++){
          if(x<10){
            var tmp = this.campinvs[x];
            this.invitees.push({
            id: tmp.camp_inv_id,
            name: tmp.camp_inv_name,
            email: tmp.camp_inv_email,
            mobile: tmp.camp_inv_mob
          });
          }
        }

      },
      async initCamp(campId) {

        try {

          const res = await getRefById(campId);

          if (!res.status) return;

          const campDt = res.ref_dt || {};
          const invs = res.invs || [];
          const follows = res.follows || [];

          /* ================= CAMPAIGN ================= */

          this.ref_camp_id = campDt.ref_camp_id;
          this.ref_camp_name = campDt.ref_camp_name || "";
          this.ref_camp_desc = campDt.ref_camp_desc || "";

          this.selectedTemplate = campDt.ref_camp_template || "temp1";

          this.businessName = campDt.ref_camp_business || "Your Business";

          /* ================= LOGO ================= */

          if (campDt.ref_camp_logo) {
            this.businessLogoPreview = campDt.ref_camp_logo;
          }

          /* ================= REWARD ================= */

          this.reward_enabled = campDt.ref_reward_enabled == "1";

          this.reward_type = campDt.ref_reward_type || "percent";
          this.reward_value = campDt.ref_reward_value || "";

          /* ================= INVITEES ================= */

          this.invitees = invs.map(inv => ({
            id: inv.ref_inv_id,
            name: inv.ref_inv_name,
            email: inv.ref_inv_email,
            mobile: inv.ref_inv_mobile
          }));

          /* ================= EMAIL WORKFLOWS ================= */

          if (follows.length > 0) {

            this.emailWorkflows = follows.map(w => ({
              id: w.ref_work_id,
              step: w.ref_work_step,
              delay_value: w.ref_work_delay_value,
              delay_unit: w.ref_work_delay_unit,
              subject: w.ref_work_subject,
              message: w.ref_work_message,
              trigger: w.ref_work_trigger
            }));

          }

          this.toast.success("Campaign loaded");

        }
        catch (err) {
          console.error(err);
          this.toast.error("Failed to load campaign");
        }

      },
      removeLogo() {

        this.businessLogo = null;
        this.businessLogoPreview = null;

        if (this.$refs.logoInput) {
          this.$refs.logoInput.value = "";
        }

      },
      handleLogoUpload(e) {

        const file = e.target.files[0];
        if (!file) return;

        this.businessLogo = file;

        const reader = new FileReader();

        reader.onload = (evt) => {
          this.businessLogoPreview = evt.target.result;
        };

        reader.readAsDataURL(file);

      },
      removeFile() {

        if (this.$refs.csvInput) {
          this.$refs.csvInput.value = null;
          this.$refs.csvInput.value = "";
        }

        this.invfile = null;
        this.invitees = [];
      },
      insertVariable(workflowIndex, variableKey) {
        this.emailWorkflows[workflowIndex].message += " " + variableKey;
      },
      clearList() {
        this.invitees = [];
      },
      listNow() {
        window.location.href = "/reffrals";
      },
      removeWorkflow(index) {
        this.emailWorkflows.splice(index, 1);
      },
      addWorkflow() {
        if( this.emailWorkflows.length>5){
          this.toast.error("Can not add more then5 workflows");
          return;
        }
        this.emailWorkflows.push({
          id: Date.now(),
          step: this.emailWorkflows.length + 1,
          delay_value: 0,
          delay_unit: "days",
          trigger: "on_signup",
          subject: "",
          message: ""
        });

      },
      downloadQR() {

        const canvas = this.$refs.qrCanvas;
        if (!canvas) return;

        const link = document.createElement("a");
        link.download = "reviewsfix_qr.png";
        link.href = canvas.toDataURL("image/png");
        link.click();
      },
      copyEmbed() {
        navigator.clipboard.writeText(this.embedCode);
        this.toast.success("Embed code copied");
      },
       async generateQR() {

  if (!this.publicLink || !this.$refs.qrCanvas) return;

  try {

    const canvas = this.$refs.qrCanvas;
    const ctx = canvas.getContext("2d");

    const size = 180;   // fits inside qr-preview (200px box)

    canvas.width = size;
    canvas.height = size;

    await QRCode.toCanvas(canvas, this.publicLink, {
      width: size,
      margin: 0,
      color: {
        dark: "#197fe6",
        light: "#ffffff"
      },
      errorCorrectionLevel: "H"
    });

    const logo = new Image();
    logo.src = "/images/logo.png";

    logo.onload = () => {

      const logoSize = size * 0.25;
      const x = (size - logoSize) / 2;
      const y = (size - logoSize) / 2;

      ctx.fillStyle = "#ffffff";
      ctx.beginPath();
      ctx.arc(size / 2, size / 2, logoSize / 2 + 4, 0, Math.PI * 2);
      ctx.fill();

      ctx.drawImage(logo, x, y, logoSize, logoSize);

    };

  } catch (err) {
    console.error("QR generation failed", err);
  }

},

      copyLink() {
        navigator.clipboard.writeText(this.publicLink);
        this.toast.success("Copied");
      },
      triggerFileUpload() {
        this.$refs.csvInput.click();
      },
      handleFileUpload(e) {

        const file = e.target.files[0];
        if (!file) return;

        this.invfile = file;
        this.invitees = [];

        const reader = new FileReader();

        reader.onload = (evt) => {

          const data = new Uint8Array(evt.target.result);
          const workbook = XLSX.read(data, { type: "array" });

          const sheet = workbook.Sheets[workbook.SheetNames[0]];
          const rows = XLSX.utils.sheet_to_json(sheet);

          const limitedRows = rows.slice(0, 1000);   // limit

          const previewRows = limitedRows.slice(0, 10); // preview

          previewRows.forEach(row => {

            this.invitees.push({
              id: Date.now() + Math.random(),
              name: row.Name || row.name || "",
              email: row.Email || row.email || "",
              mobile: row.Mobile || row.mobile || ""
            });

          });

          const remaining = limitedRows.length - previewRows.length;

          if (remaining > 0) {
            this.toast.info(
              `${previewRows.length} shown. ${remaining} more will upload with file`
            );
          }

        };

        reader.readAsArrayBuffer(file);
      },
      downloadSampleCSV() {

        const csvContent =
          "Name,Email,Mobile\n" +
          "John Doe,john@example.com,(000) 000 0000\n" +
          "Jane Smith,jane@example.com,(000) 000 0000\n";

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = "sample_referral_upload.csv";
        link.click();

        URL.revokeObjectURL(url);
      },
      openSingleInvite() {
        this.singleInvite = {
          ref_name: "",
          ref_email: "",
          ref_mobile: ""
        };
        this.showSingleInvite = true;
      },
      closeSingleInvite() {
        this.showSingleInvite = false;
      },
      saveSingleInvite() {

        if (!this.singleInvite.ref_name.trim()) {
          this.toast.error("Name required");
          return;
        }

        if (!this.singleInvite.ref_email.trim()) {
          this.toast.error("Email required");
          return;
        }

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(this.singleInvite.ref_email)) {
          this.toast.error("Invalid email");
          return;
        }

        this.invitees.push({
          id: Date.now(),
          name: this.singleInvite.ref_name,
          email: this.singleInvite.ref_email,
          mobile: this.singleInvite.ref_mobile
        });

        this.closeSingleInvite();
      },
      async nextNow() {

        // Normal step navigation
        if (this.progress.step < 4) {
          if (this.progress.step == 1) {
            if (this.ref_camp_name.length <= 0) {
              this.toast.error("Campaign Name Required");
              return;
            }
            if (this.ref_camp_desc.length <= 0) {
              this.toast.error("Campaign Details Required");
              return;
            }
          }
          if (this.progress.step == 2) {
            if (this.invitees.length <= 0) {
              this.toast.error("Add Some invitees");
              return;
            }
          }
          this.progress.step++;
          return;
        }

        // ================================
        // FINAL STEP → CREATE REFERRAL CAMPAIGN
        // ================================

        try {

          const tmp = sessionStorage.getItem("ldata") || "";
          let user_id = "";

          if (tmp && tmp.length > 0) {
            user_id = JSON.parse(tmp).user_id;
          }

          var invsts = [];

          for(var x=0;x<this.campinvs.length;x++){
         
            var tmp1 = this.campinvs[x];
            invsts.push({
            id: tmp1.camp_inv_id,
            name: tmp1.camp_inv_name,
            email: tmp1.camp_inv_email,
            mobile: tmp1.camp_inv_mob
          });
          
        }

          const payload = {
            ref_id: this.ref_camp_id || "",
            ref_user: user_id,
            ref_name: this.ref_camp_name,
            ref_desc: this.ref_camp_desc,
            ref_template: this.selectedTemplate,
            ref_business_name: this.businessName,
            ref_business_desc: this.businessDesc,
            reward_enabled: this.reward_enabled ? 1 : 0,
            reward_type: this.reward_enabled ? this.reward_type : "",
            reward_value: this.reward_enabled ? this.reward_value : "",
            email_enabled: this.email_enabled ? 1 : 0,
            email_subject: this.email_enabled ? this.email_subject : "",
            email_message: this.email_enabled ? this.email_message : "",
            invitees: invsts.length>0?JSON.stringify(invsts):this.invfile ? [] : JSON.stringify(this.invitees),
            email_workflows: JSON.stringify(this.emailWorkflows)
          };

          if (this.businessLogo) {
            payload.ref_logo = this.businessLogo;
          }

          if (this.invfile) {
            payload.invfile = this.invfile;
          }
          const res = await createReferralCampaign(payload);

          if (res.status) {

            this.ref_camp_id = res.ref_id;  // 👈 IMPORTANT from backend
            this.toast.success("Referral Campaign Created");

            this.getPubList1Now();


            // Move to final QR screen
            this.progress.step = 5;

          } else {
            this.toast.error(res.success || "Creation failed");
          }

        } catch (err) {
          console.error(err);
          this.toast.error("Server error");
        }
      },
      async getPubList1Now() {
        const url = mainBaseUrl + "referral/" + this.ref_camp_id;
        const tmp = sessionStorage.getItem("ldata") || "";
        let user_id = "";

        if (tmp && tmp.length > 0) {
          user_id = JSON.parse(tmp).user_id;
        }
        const res1 = await getQrUrl(url, "ref", this.ref_camp_id, user_id);
        if (!res1.status) return;
        this.publicLink1 = apiBaseUrl + res1.link;
        this.generateQR();
      },
      backNow() {
        if (this.progress.step > 1) {
          this.progress.step--;
        }
      }

    }

  };
</script>
<style scoped>
  /* ================= PAGE ================= */

  .wizard-page {
    background: #f6f7f8;
    min-height: 100vh;
    padding: 30px;
    display: flex;
    flex-direction: column;
    gap: 18px;
  }

  /* ================= HEADER ================= */

  .wizard-header {
    background: white;
    border-radius: 18px;
    padding: 18px 24px;
    border: 1px solid #e2e8f0;
  }

  .wizard-progress {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .progress-left span {
    font-weight: 700;
    color: #197fe6;
  }

  .progress-left small {
    display: block;
    font-size: 12px;
    color: #64748b;
    margin-top: 2px;
  }

  .progress-right {
    font-weight: 800;
    font-size: 14px;
  }

  .progress-bar {
    margin-top: 12px;
    height: 6px;
    background: #f1f5f9;
    border-radius: 20px;
    overflow: hidden;
  }

  .progress-fill {
    height: 100%;
    background: #197fe6;
    transition: 0.3s;
  }

  /* ================= BODY ================= */

  .wizard-body {
    background: white;
    border-radius: 18px;
    border: 1px solid #e2e8f0;
    padding: 32px 36px;
    flex: 1;
  }

  h1 {
    font-size: 26px;
    font-weight: 800;
    margin-bottom: 6px;
    color: #0f172a;
  }

  p {
    font-size: 14px;
    color: #64748b;
    margin-bottom: 24px;
  }

  /* ================= GRIDS ================= */

  .platform-grid,
  .invite-grid,
  .template-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 16px;
  }

  /* ================= CARDS ================= */

  .platform-card,
  .invite-card,
  .template-card {
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 18px;
    background: white;
    cursor: pointer;
    transition: 0.2s;
    position: relative;
  }

  .platform-card:hover,
  .invite-card:hover,
  .template-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.05);
  }

  .platform-card.active,
  .invite-card.active,
  .template-card.active {
    border: 2px solid #197fe6;
  }

  /* ================= ICONS ================= */

  .platform-icon,
  .invite-icon {
    width: 42px;
    height: 42px;
    border-radius: 12px;
    margin-bottom: 10px;
  }

  .google {
    background: #eef2ff;
  }

  .facebook {
    background: #eff6ff;
  }

  .custom {
    background: #fff7ed;
  }

  .upload {
    background: #eff6ff;
  }

  .manual {
    background: #ecfdf5;
  }

  .zapier {
    background: #fef3c7;
  }

  /* ================= TEXT ================= */

  .platform-card h3,
  .invite-card h3,
  .template-card strong {
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 4px;
    color: #0f172a;
  }

  .platform-card p,
  .invite-card p,
  .template-card small {
    font-size: 12.5px;
    color: #64748b;
  }

  /* ================= BUTTONS ================= */

  .connected-btn,
  .ghost-btn,
  .outline-btn {
    margin-top: 12px;
    width: 100%;
    height: 36px;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    transition: 0.15s;
  }

  .connected-btn {
    background: #197fe6;
    color: white;
    border: none;
  }

  .connected-btn:hover {
    background: #0f6ad6;
  }

  .ghost-btn {
    background: #f1f5f9;
    border: 1px solid #e2e8f0;
  }

  .ghost-btn:hover {
    background: #e2e8f0;
  }

  .outline-btn {
    background: white;
    border: 1px dashed #cbd5f5;
  }

  .outline-btn:hover {
    border-color: #197fe6;
    color: #197fe6;
  }

  /* ================= DESIGN LAYOUT ================= */

  .design-layout {
    display: grid;
    grid-template-columns: 1.2fr 0.8fr;
    gap: 26px;
  }

  .templates-section,
  .preview-card,
  .branding-controls {
    border: 1px solid #e2e8f0;
    border-radius: 18px;
    padding: 18px;
    background: white;
  }

  .preview-section {
    position: sticky;
    top: 20px;
  }

  .preview-ui {
    margin-top: 16px;
    border-radius: 14px;
    padding: 18px;
    background: #f8fafc;
  }

  .fake-stars {
    font-size: 18px;
    color: #fbbf24;
    margin-bottom: 10px;
  }

  .fake-text {
    height: 10px;
    background: #e2e8f0;
    border-radius: 6px;
    margin-bottom: 8px;
  }

  .fake-button {
    height: 32px;
    background: #197fe6;
    border-radius: 10px;
  }

  .ui-bold {
    background: linear-gradient(135deg, #197fe6, #60a5fa);
    color: white;
  }

  .ui-compact {
    background: #0f172a;
    color: white;
  }

  /* ================= FOLLOWUPS ================= */

  .sequence-card {
    display: flex;
    gap: 14px;
    margin-top: 12px;
  }

  .step-indicator {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #197fe6;
    color: white;
    font-size: 12px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .card-content {
    flex: 1;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    padding: 16px;
  }

  .sequence-header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .sequence-title {
    border: none;
    font-weight: 700;
    font-size: 13px;
  }

  .remove-step {
    margin-left: auto;
    border: none;
    background: none;
    cursor: pointer;
    color: #94a3b8;
  }

  .remove-step:hover {
    color: #ef4444;
  }

  .add-step-btn {
    height: 36px;
    padding: 0 16px;
    border-radius: 12px;
    background: #0f172a;
    color: white;
    border: none;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
  }

  /* ================= INPUTS ================= */

  label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    color: #64748b;
    margin-top: 10px;
    display: block;
  }

  input,
  textarea {
    width: 100%;
    height: 36px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    padding: 0 10px;
    font-size: 13px;
    margin-top: 4px;
  }

  textarea {
    height: 70px;
    resize: none;
    padding-top: 8px;
  }

  /* ================= FOOTER ================= */

  .wizard-footer {
    background: white;
    border-radius: 18px;
    border: 1px solid #e2e8f0;
    padding: 16px 22px;
    display: flex;
    align-items: center;
  }

  .footer-back {
    border: none;
    background: none;
    font-weight: 700;
    color: #64748b;
    cursor: pointer;
  }

  .footer-next {
    margin-left: auto;
    height: 38px;
    padding: 0 22px;
    border-radius: 12px;
    border: none;
    background: #197fe6;
    color: white;
    font-size: 13px;
    font-weight: 800;
    cursor: pointer;
  }

  .footer-next:hover {
    background: #0f6ad6;
  }

  /* ================= RESPONSIVE ================= */

  @media (max-width: 900px) {

    .wizard-page {
      padding: 16px;
    }

    .wizard-body {
      padding: 22px;
    }

    .design-layout {
      grid-template-columns: 1fr;
    }

    .footer-next,
    .footer-back {
      width: 100%;
    }

  }

  /* ================= CAMPAIGN BASIC BOX ================= */

  .camp-basic-box {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 16px;
    margin-bottom: 22px;
  }

  .camp-basic-box label:first-child {
    margin-top: 0;
  }

  /* ================= TEMPLATE PREVIEW ================= */

  .template-preview {
    height: 20rem;
    border-radius: 12px;
    margin-bottom: 12px;
    background: #f1f5f9;
    border: 1px solid #f1f5f9;
    position: relative;
    overflow: hidden;
  }

  /* Fake preview visual styles */

  .preview-modern {
    background: linear-gradient(135deg, #eef2ff, #f8fafc);
  }

  .preview-bold {
    background: linear-gradient(135deg, #197fe6, #60a5fa);
  }

  .preview-compact {
    background: linear-gradient(135deg, #0f172a, #334155);
  }

  /* ================= TEMPLATE INFO ================= */

  .template-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-bottom: 10px;
  }

  /* ================= PREVIEW LOGO ================= */

  .preview-logo {
    width: auto;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    font-size: 14px;
    overflow: hidden;
  }

  .preview-logo img {
    width: auto;
    height: 4rem;
    object-fit: cover;
  }

  /* ================= SMART STOP ================= */

  .smart-stop {
    margin-bottom: 18px;
    box-shadow: 0 10px 25px rgba(25, 127, 230, 0.08);
  }

  /* ================= QR / FINAL SCREEN ================= */

  .launch-grid {
    display: grid;
    grid-template-columns: 260px 1fr;
    gap: 22px;
    margin-top: 12px;
  }

  .qr-card {
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 18px;
    background: white;
    text-align: center;
  }

  .qr-preview {
    height: 200px;
    border-radius: 14px;
    background: #f8fafc;
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px dashed #cbd5f5;
  }

  .url-section h3 {
    font-size: 15px;
    font-weight: 800;
    margin-bottom: 10px;
    color: #0f172a;
  }

  .url-box {
    display: flex;
    gap: 10px;
  }

  .url-box input {
    flex: 1;
    background: #f8fafc;
  }

  .url-box button {
    height: 36px;
    padding: 0 18px;
    border-radius: 10px;
    border: none;
    background: #197fe6;
    color: white;
    font-size: 12.5px;
    font-weight: 700;
    cursor: pointer;
  }

  .url-box button:hover {
    background: #0f6ad6;
  }

  /* ================= RESPONSIVE FIX ================= */

  @media (max-width: 900px) {

    .launch-grid {
      grid-template-columns: 1fr;
    }

  }

  .step-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* ⭐ THIS FIXES VERTICAL MISALIGNMENT */
    gap: 12px;
    margin-bottom: 18px;
  }

  /* Prevent text block from stretching weirdly */
  .step-header>div {
    display: flex;
    flex-direction: column;
  }

  /* Stable Add Step button */
  .add-step-btn {
    height: 38px;
    padding: 0 18px;
    border-radius: 12px;
    background: #0f172a;
    color: white;
    border: none;
    font-size: 13px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    white-space: nowrap;
    /* ⭐ prevents wrapping jump */
    flex-shrink: 0;
    /* ⭐ prevents compression */
  }

  /* Icon size consistency */
  .add-step-btn span {
    font-size: 18px;
  }

  .embed-section {
    margin-top: 22px;
  }

  .code-box {
    margin-top: 10px;
    background: #0f172a;
    color: #e2e8f0;
    padding: 14px;
    border-radius: 12px;
    font-size: 11px;
    position: relative;
    overflow-x: auto;
  }

  .code-box code {
    white-space: pre-line;
    font-family: monospace;
  }

  /* ================= MODAL OVERLAY ================= */

  .modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.55);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    animation: fadeIn 0.2s ease;
  }

  /* ================= MODAL CARD ================= */

  .modal-card {
    width: 460px;
    max-width: 95%;
    background: #ffffff;
    border-radius: 20px;
    padding: 24px;
    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.15);
    animation: scaleIn 0.2s ease;
    display: flex;
    flex-direction: column;
  }

  /* ================= MODAL HEADER ================= */

  .modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;
  }

  .modal-header h3 {
    font-size: 18px;
    font-weight: 800;
    color: #0f172a;
    margin: 0;
  }

  .modal-header button {
    border: none;
    background: none;
    font-size: 18px;
    cursor: pointer;
    color: #64748b;
    transition: 0.2s;
  }

  .modal-header button:hover {
    color: #ef4444;
  }

  /* ================= MODAL BODY ================= */

  .modal-body {
    display: flex;
    flex-direction: column;
  }

  .modal-body label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    color: #64748b;
    margin-top: 12px;
  }

  .modal-body input {
    width: 100%;
    height: 38px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    padding: 0 12px;
    font-size: 13px;
    margin-top: 6px;
    transition: 0.2s;
  }

  .modal-body input:focus {
    outline: none;
    border-color: #197fe6;
    box-shadow: 0 0 0 3px rgba(25, 127, 230, 0.15);
  }

  /* ================= MODAL FOOTER ================= */

  .modal-footer {
    margin-top: 22px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }

  .modal-footer .ghost-btn,
  .modal-footer .connected-btn {
    height: 38px;
    padding: 0 18px;
    border-radius: 12px;
    font-size: 13px;
    font-weight: 700;
  }

  /* ================= ANIMATIONS ================= */

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  @keyframes scaleIn {
    from {
      opacity: 0;
      transform: scale(0.95);
    }

    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  /* ================= RESPONSIVE ================= */

  @media (max-width: 500px) {
    .modal-card {
      padding: 18px;
    }

    .modal-header h3 {
      font-size: 16px;
    }
  }

  /* ================= INVITEE LIST ================= */

  .invite-list {
    margin-top: 30px;
    padding-top: 18px;
    border-top: 1px solid #e2e8f0;
  }

  .invite-list-header h3 {
    font-size: 15px;
    font-weight: 800;
    color: #0f172a;
    margin-bottom: 12px;
  }

  .invite-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    background: #f8fafc;
    margin-bottom: 10px;
    transition: 0.2s;
  }

  .invite-row:hover {
    background: #eef2ff;
  }

  .invite-info strong {
    display: block;
    font-size: 13px;
    color: #0f172a;
  }

  .invite-info small {
    display: block;
    font-size: 12px;
    color: #64748b;
  }

  .remove-invite {
    border: none;
    background: none;
    font-size: 16px;
    cursor: pointer;
    color: #94a3b8;
    transition: 0.2s;
  }

  .remove-invite:hover {
    color: #ef4444;
  }

  .small {
    height: 32px !important;
    font-size: 12px !important;
    margin-top: 10px;
  }

  /* ================= FINAL BUTTON FIXES ================= */

  .full-btn {
    width: 100%;
    height: 40px;
    margin-top: 14px;
    border-radius: 12px;
    font-weight: 700;
  }

  /* QR button */
  .qr-card .outline-btn {
    border: 1px solid #197fe6;
    color: #197fe6;
  }

  .qr-card .outline-btn:hover {
    background: #197fe6;
    color: white;
  }

  /* Copy link button */
  .url-box button {
    min-width: 110px;
    height: 40px;
    border-radius: 10px;
    font-weight: 700;
  }

  /* Embed section spacing */
  .embed-section {
    margin-top: 24px;
  }

  .referral-preview-form {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 14px;
  }

  .referral-preview-form input,
  .referral-preview-form textarea {
    background: #f1f5f9;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 6px;
    font-size: 12px;
  }

  .referral-preview-form button {
    background: #197fe6;
    color: white;
    border: none;
    padding: 6px;
    border-radius: 8px;
  }

  /* =========================================================
   FIX 1 — REMOVE INPUT HEIGHT CONFLICT
========================================================= */

  input,
  textarea,
  select {
    height: auto !important;
    min-height: 40px;
    padding: 10px 12px !important;
    font-size: 13px;
    border-radius: 12px;
  }

  textarea {
    min-height: 90px;
  }

  /* =========================================================
   FIX 2 — CARD HOVER JUMP FIX
========================================================= */

  .invite-card,
  .template-card {
    transition: all 0.18s ease;
    will-change: transform;
  }

  .invite-card:hover,
  .template-card:hover {
    transform: translateY(-4px);
  }

  /* =========================================================
   FIX 3 — TEMPLATE ACTIVE VISUAL UPGRADE
========================================================= */

  .template-card.active {
    border: 2px solid #197fe6;
    box-shadow: 0 10px 25px rgba(25, 127, 230, 0.15);
  }

  /* =========================================================
   FIX 4 — PREVIEW SECTION POLISH
========================================================= */

  .preview-section {
    position: sticky;
    top: 24px;
  }

  .preview-card {
    padding: 22px !important;
  }

  .preview-brand strong {
    font-size: 15px;
  }

  .preview-brand small {
    font-size: 12px;
    color: #64748b;
  }

  /* Prevent preview overflow */
  .referral-preview-form input,
  .referral-preview-form textarea {
    width: 100%;
    box-sizing: border-box;
  }

  /* =========================================================
   FIX 5 — TOGGLE ROW ALIGNMENT
========================================================= */

  .toggle-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 18px;
    background: #f8fafc;
    border-radius: 14px;
    border: 1px solid #e2e8f0;
    margin-bottom: 20px;
  }

  .toggle-row span {
    font-weight: 600;
    font-size: 14px;
  }

  /* Modern checkbox */
  .toggle-row input[type="checkbox"] {
    width: 42px;
    height: 22px;
    appearance: none;
    background: #e2e8f0;
    border-radius: 999px;
    position: relative;
    cursor: pointer;
    transition: 0.3s;
  }

  .toggle-row input[type="checkbox"]::before {
    content: "";
    width: 18px;
    height: 18px;
    background: white;
    position: absolute;
    top: 2px;
    left: 2px;
    border-radius: 50%;
    transition: 0.3s;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }

  .toggle-row input[type="checkbox"]:checked {
    background: #197fe6;
  }

  .toggle-row input[type="checkbox"]:checked::before {
    transform: translateX(20px);
  }

  /* =========================================================
   FIX 6 — QR ALIGNMENT
========================================================= */

  .qr-card {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 220px;
  }

  .qr-card canvas {
    max-width: 100%;
    height: auto;
  }

  /* =========================================================
   FIX 7 — URL BOX CLEANER LAYOUT
========================================================= */

  .url-box {
    align-items: stretch;
  }

  .url-box input {
    height: 42px;
    border-radius: 12px;
  }

  .url-box button {
    height: 42px !important;
    border-radius: 12px;
    min-width: 100px;
    font-weight: 700;
  }

  /* =========================================================
   FIX 8 — FOOTER RESPONSIVE FIX
========================================================= */

  .wizard-footer {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .footer-back {
    padding: 10px 14px;
    border-radius: 10px;
  }

  .footer-next {
    height: 44px;
    padding: 0 28px;
    border-radius: 14px;
    font-size: 14px;
  }

  /* Mobile fix */
  @media (max-width: 900px) {

    .wizard-footer {
      flex-direction: column-reverse;
      align-items: stretch;
    }

    .footer-back,
    .footer-next {
      width: 100%;
    }

  }

  /* =========================================================
   FIX 9 — CLEAN SECTION SPACING
========================================================= */

  .wizard-body>div {
    animation: fadeStep 0.25s ease;
  }

  @keyframes fadeStep {
    from {
      opacity: 0;
      transform: translateY(6px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* =========================================================
   FIX 10 — BETTER GRID COLLAPSE
========================================================= */

  @media (max-width: 1100px) {
    .design-layout {
      grid-template-columns: 1fr;
    }

    .preview-section {
      position: relative;
      top: 0;
    }
  }

  .embed-section {
    margin-top: 28px;
  }

  .code-box {
    margin-top: 12px;
    background: #0f172a;
    color: #e2e8f0;
    padding: 16px;
    border-radius: 14px;
    font-size: 12px;
    overflow-x: auto;
    line-height: 1.5;
  }

  .code-box code {
    font-family: monospace;
    white-space: pre-line;
  }

  .full-btn {
    width: 100%;
    margin-top: 14px;
  }

  /* =========================================================
   1️⃣ MODERN SWITCH TOGGLE
========================================================= */

  .toggle-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 20px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    margin-bottom: 24px;
  }

  .toggle-row span {
    font-weight: 600;
    font-size: 14px;
    color: #0f172a;
  }

  .toggle-row input[type="checkbox"] {
    appearance: none;
    width: 46px;
    height: 24px;
    background: #e2e8f0;
    border-radius: 999px;
    position: relative;
    cursor: pointer;
    transition: 0.25s;
  }

  .toggle-row input[type="checkbox"]::before {
    content: "";
    width: 20px;
    height: 20px;
    background: white;
    border-radius: 50%;
    position: absolute;
    top: 2px;
    left: 2px;
    transition: 0.25s;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }

  .toggle-row input[type="checkbox"]:checked {
    background: #197fe6;
  }

  .toggle-row input[type="checkbox"]:checked::before {
    transform: translateX(22px);
  }

  .toggle-row input[type="checkbox"]:checked {
    background: #197fe6;
  }

  .toggle-row input[type="checkbox"]:checked::before {
    transform: translateX(22px);
  }

  /* =========================================================
   2️⃣ REWARD SECTION FIX
========================================================= */

  select {
    width: 100%;
    height: 42px;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    padding: 0 12px;
    font-size: 13px;
    margin-top: 6px;
    background: #ffffff;
    transition: 0.2s ease;
  }

  select:focus {
    outline: none;
    border-color: #197fe6;
    box-shadow: 0 0 0 3px rgba(25, 127, 230, 0.12);
  }

  /* Reward inner spacing */
  .reward-section {
    background: #f8fafc;
    padding: 22px;
    border-radius: 16px;
    border: 1px solid #e2e8f0;
  }

  /* Percentage / coupon field spacing */
  .reward-section input {
    margin-top: 8px;
  }

  /* =========================================================
   3️⃣ EMAIL WORKFLOW CARD DESIGN
========================================================= */

  .workflow-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 18px;
    padding: 20px;
    margin-bottom: 18px;
    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.04);
    transition: all 0.2s ease;
  }

  .workflow-card:hover {
    box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);
  }

  .workflow-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
  }

  .workflow-header strong {
    font-size: 14px;
    font-weight: 700;
  }

  .workflow-header button {
    background: none;
    border: none;
    font-size: 16px;
    cursor: pointer;
    color: #94a3b8;
    transition: 0.2s;
  }

  .workflow-header button:hover {
    color: #ef4444;
  }

  /* =========================================================
   4️⃣ DELAY ROW FIX
========================================================= */

  .delay-row {
    display: flex;
    gap: 10px;
    margin-top: 6px;
  }

  .delay-row input {
    flex: 1;
  }

  .delay-row select {
    width: 120px;
  }

  /* =========================================================
   5️⃣ INPUT UNIFICATION
========================================================= */

  input,
  textarea {
    width: 100%;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    padding: 10px 12px;
    font-size: 13px;
    margin-top: 6px;
    transition: 0.2s ease;
  }

  input:focus,
  textarea:focus {
    outline: none;
    border-color: #197fe6;
    box-shadow: 0 0 0 3px rgba(25, 127, 230, 0.12);
  }

  /* Prevent textarea collapse */
  textarea {
    min-height: 100px;
    resize: vertical;
  }

  /* =========================================================
   6️⃣ ADD WORKFLOW BUTTON
========================================================= */

  .add-workflow-btn {
    margin-top: 10px;
    height: 42px;
    padding: 0 18px;
    border-radius: 14px;
    background: #0f172a;
    color: white;
    font-size: 13px;
    font-weight: 700;
    border: none;
    cursor: pointer;
    transition: 0.2s;
  }

  .add-workflow-btn:hover {
    background: #1e293b;
  }

  /* =========================================================
   7️⃣ STEP ANIMATION (SMOOTH UX)
========================================================= */

  .wizard-body>div {
    animation: fadeSlide 0.25s ease;
  }

  @keyframes fadeSlide {
    from {
      opacity: 0;
      transform: translateY(6px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* =========================================================
   8️⃣ MOBILE FIXES
========================================================= */

  @media (max-width: 768px) {

    .delay-row {
      flex-direction: column;
    }

    .delay-row select {
      width: 100%;
    }

    .toggle-row {
      padding: 14px 16px;
    }

  }

  .upload-actions {
    display: flex;
    gap: 10px;
    margin-top: 12px;
    flex-wrap: wrap;
  }

  .upload-actions .small {
    flex: 1;
  }

  .variable-insert {
    margin-top: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .variable-btn {
    background: #eef2ff;
    border: 1px solid #c7d2fe;
    color: #3730a3;
    padding: 4px 8px;
    font-size: 11px;
    border-radius: 8px;
    cursor: pointer;
    transition: 0.15s;
  }

  .variable-btn:hover {
    background: #197fe6;
    color: white;
    border-color: #197fe6;
  }

  /* ================= FILE PREVIEW ================= */

  .file-preview {
    margin-top: 16px;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f8fafc;
    transition: all .18s ease;
  }

  .file-preview:hover {
    background: #eef2ff;
    border-color: #c7d2fe;
  }

  /* FILE INFO */

  .file-info {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 13px;
    font-weight: 600;
  }

  .file-info span:first-child {
    font-size: 18px;
    color: #64748b;
  }

  .file-name {
    color: #0f172a;
    font-weight: 600;
    max-width: 240px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* REMOVE BUTTON */

  .remove-file-btn {
    border: none;
    background: #fee2e2;
    color: #ef4444;
    padding: 6px 14px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    transition: all .15s ease;
  }

  .remove-file-btn:hover {
    background: #ef4444;
    color: #ffffff;
  }

  /* ================= UPLOAD ACTION BUTTONS ================= */

  .upload-actions {
    display: flex;
    gap: 10px;
    margin-top: 14px;
    flex-wrap: wrap;
  }

  .upload-actions .small {
    flex: 1;
    height: 34px !important;
  }

  /* ================= INVITE CARD DISABLED ================= */

  .invite-card.disabled {
    opacity: 0.45;
    pointer-events: none;
  }

  /* ================= CSV UPLOAD CARD HIGHLIGHT ================= */

  .invite-card.uploading {
    border: 2px dashed #197fe6;
    background: #eef2ff;
  }

  /* ================= FILE ICON BADGE ================= */

  .file-info .material-symbols-outlined {
    background: #eef2ff;
    padding: 6px;
    border-radius: 8px;
  }

  /* ================= MOBILE FIX ================= */

  @media (max-width:600px) {

    .file-preview {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }

    .remove-file-btn {
      width: 100%;
    }

  }

  .invite-card.disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  .preview-card {
    background: #ffffff;
    border-radius: 22px;
    padding: 26px;
    border: 1px solid #e2e8f0;
    max-width: 40rem;
    margin: auto;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.05);
  }

  .preview-brand {
    text-align: center;
    margin-bottom: 16px;
  }

  .preview-logo {
    width: auto;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    margin: auto;
    font-size: 18px;
  }

  .preview-business {
    margin-top: 10px;
    font-size: 16px;
    font-weight: 700;
  }

  .preview-desc {
    font-size: 12px;
    color: #64748b;
  }

  .preview-title {
    text-align: center;
    font-size: 20px;
    font-weight: 800;
    margin-top: 12px;
  }

  .preview-subtitle {
    text-align: center;
    font-size: 13px;
    color: #64748b;
    margin-bottom: 18px;
  }

  .preview-form {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .preview-form label {
    font-size: 11px;
    font-weight: 600;
    color: #475569;
  }

  .preview-form input {
    height: 40px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    padding: 0 12px;
    background: #f8fafc;
    font-size: 13px;
  }

  .preview-form textarea {
    height: 80px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    padding: 10px 12px;
    background: #f8fafc;
    font-size: 13px;
    resize: none;
  }

  .preview-phone {
    display: flex;
    gap: 8px;
  }

  .preview-code {
    width: 70px;
    height: 40px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
  }

  .preview-phone input {
    flex: 1;
  }

  .preview-btn {
    margin-top: 10px;
    height: 42px;
    border-radius: 12px;
    background: #7aa6d1;
    color: white;
    font-weight: 700;
    border: none;
    font-size: 14px;
  }

  .logo-upload-wrapper {
    margin-top: 8px;
  }

  .logo-drop-area {
    width: 100%;
    height: 130px;
    border-radius: 16px;
    border: 2px dashed #cbd5e1;
    background: #f8fafc;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: all .2s ease;
  }

  .logo-drop-area:hover {
    border-color: #197fe6;
    background: #eef2ff;
  }

  /* PLACEHOLDER */

  .logo-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    color: #64748b;
  }

  .logo-placeholder span {
    font-size: 28px;
  }

  .logo-placeholder strong {
    font-size: 13px;
  }

  .logo-placeholder small {
    font-size: 11px;
  }

  /* IMAGE PREVIEW */

  .logo-preview {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  /* OVERLAY */

  .logo-overlay {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: rgba(15, 23, 42, 0.65);
    color: white;
    text-align: center;
    padding: 6px 0;
    font-size: 12px;
    font-weight: 600;
  }

  /* REMOVE BUTTON */

  .logo-remove {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    border: none;
    background: white;
    font-weight: 700;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
</style>